import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import SeleniumAutomation from './pages/SeleniumAutomation';
import SendKeys from './pages/SendKeys';
import Buttons from './pages/Buttons';
import Dropdown from './pages/Dropdown';
import Radio from './pages/Radio';
import Checkbox from './pages/Checkbox';
import Alert from './pages/Alert';
import WebTable from './pages/Webtable';
import WindowHandle from './pages/WindowHandle';
import Navigation from './pages/Navigation';
import Screenshot from './pages/Screenshot';
import Condition from './pages/Condition';
import ActionClass from './pages/ActionClass';
import Frames from './pages/Frames';
import ButtonFrame from './pages/ButtonFrame';
import TextAttribute from './pages/TextAttribute';
import Locators from './pages/Locators';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import PlaywrightSidebar from './components/PlaywrightSidebar';
import Footer from './components/Footer';
import UsernameFrame from './pages/UsernameFrame';
import UsernameInput from './pages/UsernameInput';
import ApiTesting from './pages/ApiTesting';
import ProductManagement from './pages/ProductManagement';
import LoginPage from './pages/LoginPage';
import Validation from './pages/Validation';
import Wait from './pages/Wait';
import FileUpload from './pages/FileUpload';
import ProductDashboard from "./pages/ProductDashboard";
import Users from "./pages/Users";
import Products from "./pages/Products";
import PlaywrightAutomation from './pages/playwright/PlaywrightAutomation';
import PlaywrightTemplate from './pages/playwright/PlaywrightTemplate';
import PwLocators from "./pages/playwright/PwLocators";
import PwActions from "./pages/playwright/PwActions";
import PwInput from "./pages/playwright/PwInput";
import PwCheckbox from "./pages/playwright/PwCheckbox";
import PwAlerts from "./pages/playwright/PwAlerts";
import PwWebTable from "./pages/playwright/PwWebTable";
import PwFormValidation from "./pages/playwright/PwFormValidation";
import PwWindows from "./pages/playwright/PwWindows";
import PwNavigation from "./pages/playwright/PwNavigation";
import PwScreenshot from "./pages/playwright/PwScreenshot";
import PwFrames from "./pages/playwright/PwFrames";
import PwWaits from "./pages/playwright/PwWaits";
import PwUpload from "./pages/playwright/PwUpload";



function LayoutRoutes() {
  const location = useLocation();

  // Pages where Navbar + Sidebar both hidden
  const hideBothLayoutPaths = [
    '/button-frame',
    '/username-frame',
    '/username-input'
  ];

  // Pages where ONLY main sidebar hidden
  const hideMainSidebarPaths = [
    '/api-testing',
    '/',
    '/product-management',
    '/login',
    '/product-dashboard',
    '/users',
    '/products'
  ];

  const hideBoth = hideBothLayoutPaths.includes(location.pathname);

  // Detect Playwright routes (include pw-* and template routes)
  const isPlaywrightRoute =
    location.pathname.startsWith('/playwright-automation') ||
    location.pathname.startsWith('/pw-') ||
    location.pathname.startsWith('/playwright-template');

  const hideMainSidebar =
    hideMainSidebarPaths.includes(location.pathname) || isPlaywrightRoute;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

      {/* Navbar */}
      {!hideBoth && <Navbar />}

      <div style={{ display: 'flex', flex: 1 }}>

        {/* Show Playwright Sidebar */}
        {isPlaywrightRoute && <PlaywrightSidebar />}

        {/* Show Main Sidebar */}
        {!hideBoth && !hideMainSidebar && <Sidebar />}

        {/* Page Content */}
        <div style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/selenium-automation" element={<SeleniumAutomation />} />
            <Route path="/playwright-automation" element={<PlaywrightAutomation />} />

            <Route path="/send_keys" element={<SendKeys />} />
            <Route path="/buttons" element={<Buttons />} />
            <Route path="/dropdown" element={<Dropdown />} />
            <Route path="/radio" element={<Radio />} />
            <Route path="/checkbox" element={<Checkbox />} />
            <Route path="/alert" element={<Alert />} />
            <Route path="/webtable" element={<WebTable />} />
            <Route path="/windowhandle" element={<WindowHandle />} />
            <Route path="/navigation" element={<Navigation />} />
            <Route path="/screenshot" element={<Screenshot />} />
            <Route path="/condition" element={<Condition />} />
            <Route path="/actionclass" element={<ActionClass />} />
            <Route path="/frames" element={<Frames />} />
            <Route path="/button-frame" element={<ButtonFrame />} />
            <Route path="/locators" element={<Locators />} />
            <Route path="/username-frame" element={<UsernameFrame />} />
            <Route path="/username-input" element={<UsernameInput />} />
            <Route path="/text_attribute" element={<TextAttribute />} />
            <Route path="/api-testing" element={<ApiTesting />} />
            <Route path="/product-management" element={<ProductManagement />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/validate" element={<Validation />} />
            <Route path="/wait" element={<Wait />} />
            <Route path="/file_upload" element={<FileUpload />} />
            <Route path="/product-dashboard" element={<ProductDashboard />} />
            <Route path="/users" element={<Users />} />
            <Route path="/products" element={<Products />} />
	          <Route path="/playwright-template" element={<PlaywrightTemplate />} />
            <Route path="/pw-locators" element={<PwLocators />} />
            <Route path="/pw-actions" element={<PwActions />} />
            <Route path="/pw-input" element={<PwInput />} />
            <Route path="/pw-checkbox" element={<PwCheckbox />} />
            <Route path="/pw-alerts" element={<PwAlerts />} />
            <Route path="/pw-webtable" element={<PwWebTable />} />
            <Route path="/pw-windows" element={<PwWindows />} />
            <Route path="/pw-navigation" element={<PwNavigation />} />
            <Route path="/pw-screenshot" element={<PwScreenshot />} />
            <Route path="/pw-frames" element={<PwFrames />} />
            <Route path="/pw-waits" element={<PwWaits />} />
            <Route path="/pw-form-validation" element={<PwFormValidation />} />
            <Route path="/pw-upload" element={<PwUpload />} />
                        
          </Routes>
        </div>
      </div>

      {!hideBoth && <Footer />}
    </div>
  );
}


function App() {
  return (
    <Router>
      <LayoutRoutes />
    </Router>
  );
}

export default App;
